import React, { useState } from "react";
import { TextField, InputAdornment } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { rcolor } from "../../style2";


const searchBoxHighlightSx = {
  borderRadius: 2,
  margin: "auto",
  maxHeight: 45,
  border: `0.5px solid ${rcolor}`,
  boxSizing: "border-box"
};
// Removed searchBoxSx, will use inline sx={{ width: '100%' }}
const clearIconSx = {
  cursor: "pointer",
  color: "rgba(0, 18, 68, 0.4)",
};
const searchIconSx = {
  color: "rgba(17, 92, 113, 0.5)",
};


const SearchBox = (props) => {
  const [value, setValue] = useState("");

  const handleChange = (event) => {
    props.onChange(event.target.value);
    setValue(event.target.value);
  };

  const handleClearButton = () => {
    props.onChange("");
    setValue("");
  };

  return (
      <TextField
        placeholder='Search'
        variant='outlined'
        fullWidth
        value={value}
        InputProps={{
          sx: searchBoxHighlightSx,
          startAdornment: (
            <InputAdornment position='start'>
              {value !== "" ? undefined : (
                <SearchIcon sx={searchIconSx} />
              )}
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position='end'>
              {value !== "" ? (
                <CloseIcon
                  sx={clearIconSx}
                  onClick={handleClearButton}
                />
              ) : undefined}
            </InputAdornment>
          ),
        }}
        onChange={handleChange}
        sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: 2,
          maxHeight: 45,
          "& fieldset": {
            borderColor: rcolor, // default
          },
          "&:hover fieldset": {
            borderColor: rcolor, // hover
          },
          "&.Mui-focused fieldset": {
            borderColor: rcolor, // focused
          },
        },
      }}

      />
  );
};

export default SearchBox;
